import { Component, Children, cloneElement, createElement } from 'react';
import PropTypes from 'prop-types';
import { any, equals, values } from 'ramda';

import FormSection from 'components/FormSection';

class FormSectionContainer extends Component {
  componentWillMount() {
    const bindHandler = i => b => this.handleComponentRenders(i, b);
    const boundIds = {};

    this.boundChildren = Children.toArray(this.props.children).map((c, i) => {
      boundIds[i] = true;
      return cloneElement(c, { onComponentRenders: bindHandler(i) });
    });

    this.setState({ ...boundIds });
  }

  handleComponentRenders(i, b) {
    this.setState({ [i]: b });
  }

  render() {
    const { children, ...other } = this.props;
    const { localeMessage, condensedView, editing } = this.context;
    return condensedView && !editing && !any(equals(true), values(this.state))
      ? null
      : createElement(FormSection, { localeMessage, ...other }, this.boundChildren);
  }
}

FormSectionContainer.contextTypes = {
  localeMessage: PropTypes.func,
  formValues: PropTypes.object,
  condensedView: PropTypes.bool,
  editing: PropTypes.bool,
};

FormSectionContainer.propTypes = {
  children: PropTypes.node,
};

export default FormSectionContainer;
